import { SourceInfo, Track } from 'plyr';

import { VideoInfo } from './types';

export class PlyrVideoUtils {
  private static readonly _defaultTrackInfo: Omit<Track, 'src'> = {
    kind: 'captions',
    srcLang: 'en',
    label: 'English captions',
    default: true,
  };

  static generateSourceInfo({
    videoSrc,
    posterSrc,
    captionsSrc,
  }: VideoInfo): SourceInfo {
    return {
      type: 'video',
      sources: [
        {
          type: 'video/mp4',
          size: 720,
          src: videoSrc,
        },
      ],
      poster: posterSrc,
      tracks: PlyrVideoUtils.generateTrackInfo(captionsSrc),
    };
  }

  // @TODO: improve by using passed data when respective updates will be implemented
  static generateTrackInfo(trackSrc?: string): Track[] | undefined {
    if (!trackSrc) return undefined;

    return [
      {
        ...this._defaultTrackInfo,
        src: trackSrc,
      },
    ];
  }

  static isVideo(resourceUri: string) {
    return resourceUri.toLowerCase().endsWith('.mp4');
  }
}
